import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CodaltComponent} from '../codalt/codalt.component';
import {Ttm} from '../../classes/ttm';
import {TtmType} from '../../classes/ttmtype';
import {TtmStatus} from '../../classes/ttmstatus';
import {FormControl, FormGroup} from '@angular/forms';
import {TtmService} from '../../services/ttm.service';

@Component({
    selector: 'app-ttm-split',
    templateUrl: './ttm-split.component.html',
    styleUrl: './ttm-split.component.scss'
})
export class TtmSplitComponent extends CodaltComponent implements OnInit {

    ttmTypes: TtmType[];
    ttmStatuses: TtmStatus[];
    ttm: Ttm;
    checkedCount: number;

    checked = new FormGroup({});

    constructor(public dialogRef: MatDialogRef<TtmSplitComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    ttm: Ttm
                },
                public ttmService: TtmService) {
        super();
    }

    ngOnInit() {
        this.ttm = this.data.ttm;
        this.subscriptions.add(this.ttmService.statuses().subscribe(statuses => {
            this.ttmStatuses = statuses.data;
        }));
        this.subscriptions.add(this.ttmService.types().subscribe(types => {
            this.ttmTypes = types.data;
        }));
        this.ttm.entities.forEach(entity => {
            this.checked.addControl(`${entity.id}`, new FormControl(true));
        });
        this.checkedCount = this.ttm.entities.length;
        this.subscriptions.add(this.checked.valueChanges.subscribe(checked => {
            this.checkedCount = Object.keys(checked).filter(key => !!checked[key]).length;
        }));
    }

    split() {
        this.subscriptions.add(this.ttmService.split(this.ttm.id, this.ttm.entities.filter(e => this.checked.value[e.id]).map(e => e.id)).subscribe(ttms => {
            this.dialogRef.close({
                ttm: ttms.data[0],
                newTtm: ttms.data[1]
            });
        }));
    }
}
